import { FETCH_LANGUAGES } from '../actions/type';

const initialState = {
    languages: ''
};

export default function(state = initialState, actions){
    switch(actions.type){
        case FETCH_LANGUAGES:
            return {
                ...state,
                languages: actions.payload
            }
        default:
            return state;
    }
}

